import React, { useState } from 'react';
import { Input, Button, ButtonGroup, ButtonToolbar, Row, Col, Container, Card, CardBody, CardTitle, CardText, Label } from 'reactstrap';
import ReactSpeedometer from "react-d3-speedometer"
// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import Example from '../../../components/charts/BarChart';
import { useEffect } from 'react';
import { glosarioProceso1 } from '../utils/glosarioSolicitudes';

//GCP Functions
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

//API Calls
const informacionReporte = functionsHttpsCallable('ape_getInfogramaReclutamiento');

const mapStateToProps = state => ({
    usuarioActivo: state
})


const ModalInformeRequerimientos = (props) => {
    let todayDate = new Date(Date.now())
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [gerenciaActiva, setGerenciaActiva] = useState();
    const [dataAPES, setDataAPES] = useState({});
    const [contratoActivo, setContratoActivo] = useState();
    const [startDate, setStartDate] = useState(new Date(todayDate.getFullYear(), todayDate.getMonth() - 1, todayDate.getDate()));
    const [endDate, setEndDate] = useState(new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate()));

    useEffect(() => {
        getDataInicial()
    }, [startDate, endDate])

    useEffect(() => {
        if (gerenciaActiva !== undefined) {
            const dataGerenciaTemp = getData()
            setContratoActivo(Object.keys(dataGerenciaTemp.data)[0])
        }
    }, [gerenciaActiva])

    const formatData = (data) => {
        const listadoGerencias = ['GERENCIA O&M 1', 'GERENCIA O&M 2', 'GERENCIA O&M 3', 'GERENCIA O&M 4', 'GERENCIA O&M 5', 'ADMINISTRATIVA']
        const listadoFacturacion = data !== undefined ? (data.length > 0 ? data.filter(ape => ape.facturacion === 'Si') : []) : [];
        const listadoCerradas = data !== undefined ? (data.length > 0 ? data.filter(ape => ape.estado === 'CONTRATACION') : []) : [];
        let returnData = {
            total: data !== undefined ? data.length : 0,
            facturacion: listadoFacturacion.length ?? 0,
            cerradas: listadoCerradas.length ?? 0
        }
        listadoGerencias.forEach((gerencia) => {
            let tempArr = data.filter(ape => ape.gerencia === gerencia);
            let tempArr3 = tempArr.filter(ape => ape.facturacion === 'Si');
            let tempArrContratacion = tempArr.filter(ape => ape.estado === 'CONTRATACION');
            let tempData = [];
            let dataPorContratos = {};
            let acum = 0
            let contratos = tempArr.map((ape, index) => { return ape.contrato })
            let newContratos = contratos.filter(onlyUnique)
            newContratos.forEach((contrato) => {
                dataPorContratos[contrato] = []
                let tempArr4 = tempArr.filter(ape => ape.contrato === contrato)
                Object.keys(glosarioProceso1).forEach((key, index) => {
                    let tempArr2 = tempArr4.filter(ape => ape.estado === glosarioProceso1[key].id)
                    if (tempArr2.length > 0) {
                        acum += tempArr2.length
                        dataPorContratos[contrato].push({ name: glosarioProceso1[key].name, q: tempArr2.length });
                    }
                })
            })
            returnData[gerencia] = { facturacion: tempArr3.length, data: dataPorContratos, total: acum, contratos: newContratos, cerradas: tempArrContratacion.length ?? 0 };
        });
        return returnData
    }

    const onlyUnique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    const getDataInicial = async () => {
        if (endDate > startDate) {
            const bodyConsulta = {
                fechaInicio: startDate.toISOString().split('T')[0],
                fechaFin: endDate.toISOString().split('T')[0],
                codigoEmpresa: userData.codigoEmpresa
            }
            let data = await informacionReporte(bodyConsulta)
            let formatedData = formatData(data !== undefined ? data.data.data : [])
            setDataAPES(formatedData)
            setGerenciaActiva(1)
        }
    }


    const getData = () => {
        switch (gerenciaActiva) {
            case 2:
                return dataAPES['GERENCIA O&M 2']
            case 3:
                return dataAPES['GERENCIA O&M 3']
            case 4:
                return dataAPES['GERENCIA O&M 4']
            case 5:
                return dataAPES['GERENCIA O&M 5']
            case 6:
                return dataAPES['ADMINISTRATIVA']
            case 1:
            default:
                return dataAPES['GERENCIA O&M 1']
        }
    }

    const handleClick = (i) => {
        setGerenciaActiva(i)
    }
    const dataGerencia = getData()
    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                size='xl'
                title={'Informe de Requerimientos'}
                nonFooter={true}
            >
                <Container>
                    <Row>
                        <Col lg='6' md='6' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                            <Label for="exampleSelect">Fecha de Inicio</Label>
                            <Input
                                id="startDate"
                                name="datetime"
                                value={startDate ? startDate.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                                onChange={(e) => setStartDate(new Date(e.target.value))}
                                type="date"
                            />
                        </Col>
                        <Col lg='6' md='6' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                            <Label for="exampleSelect">Fecha de Fin</Label>
                            <Input
                                id="endDate"
                                name="datetime"
                                value={endDate ? endDate.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                                onChange={(e) => setEndDate(new Date(e.target.value))}
                                type="date"
                            />
                        </Col>
                    </Row>
                    <Row className='button-center'>
                        <Col>
                            <ButtonToolbar>
                                <ButtonGroup>
                                    <Button key='g1Button' outline color="primary" onClick={() => handleClick(1)} active={gerenciaActiva === 1} size="sm">{'GERENCIA O&M 1'}</Button>
                                    <Button key='g2Button' outline color="primary" onClick={() => handleClick(2)} active={gerenciaActiva === 2} size="sm">{'GERENCIA O&M 2'}</Button>
                                    <Button key='g3Button' outline color="primary" onClick={() => handleClick(3)} active={gerenciaActiva === 3} size="sm">{'GERENCIA O&M 3'}</Button>
                                    <Button key='g4Button' outline color="primary" onClick={() => handleClick(4)} active={gerenciaActiva === 4} size="sm">{'GERENCIA O&M 4'}</Button>
                                    <Button key='g5Button' outline color="primary" onClick={() => handleClick(5)} active={gerenciaActiva === 5} size="sm">{'GERENCIA O&M 5'}</Button>
                                    <Button key='g6Button' outline color="primary" onClick={() => handleClick(6)} active={gerenciaActiva === 6} size="sm">{'ADMINISTRATIVA'}</Button>
                                </ButtonGroup>
                            </ButtonToolbar>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='modal-resumen-recl-left' lg='6' md='12' xs="12">
                            <Row className='row-left'>
                                <Col lg='4' md='12' xs="12">
                                    <Card>
                                        <CardBody>
                                            <CardTitle tag="h5">{dataAPES.total ?? 0}</CardTitle>
                                            <CardText>Total Requerimientos General</CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col lg='4' md='12' xs="12">
                                    <Card>
                                        <CardBody>
                                            <CardTitle tag="h5">{dataAPES.cerradas ?? 0}</CardTitle>
                                            <CardText>Cerradas General</CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col lg='4' md='12' xs="12">
                                    <Card>
                                        <CardBody>
                                            <CardTitle tag="h5">{dataAPES.facturacion ?? 0}</CardTitle>
                                            <CardText>Impacta Facturación General</CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg='4' md='12' xs="12">
                                    <Card>
                                        <CardBody>
                                            <CardTitle tag="h5">{dataGerencia ? dataGerencia.total : 0}</CardTitle>
                                            <CardText>Total Requerimientos</CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col lg='4' md='12' xs="12">
                                    <Card>
                                        <CardBody>
                                            <CardTitle tag="h5">{dataGerencia ? dataGerencia.cerradas : 0}</CardTitle>
                                            <CardText>Cerradas</CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col lg='4' md='12' xs="12">
                                    <Card>
                                        <CardBody>
                                            <CardTitle tag="h5">{dataGerencia ? dataGerencia.facturacion : 0}</CardTitle>
                                            <CardText>Impacta Facturación</CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row className='tachometer-row'>
                                <ReactSpeedometer
                                    maxValue={100}
                                    value={dataGerencia ? dataGerencia.cerradas / dataGerencia.total : 0}
                                    labelFontSize={'24px'}
                                    valueTextFontSize={'24px'}
                                    valueTextFontWeight={'500'}
                                    needleHeightRatio={0.6}
                                    needleColor={'#8884d8'}
                                    paddingHorizontal={17}
                                    paddingVertical={17}
                                    currentValueText={'Avance: ${value} %'}
                                    textColor={'#8884d8'}
                                />
                            </Row>
                        </Col>
                        <Col className='modal-resumen-recl-right' lg='6' md='12' xs="12">
                            <Row className='top-row button-center' lg='6' md='12' xs="12">
                                <ButtonToolbar>
                                    <ButtonGroup>
                                        {dataGerencia ? dataGerencia.contratos.map((contrato) => {
                                            return <Button key={`${contrato}Button`} outline color="primary" onClick={() => setContratoActivo(contrato)} active={contratoActivo === contrato} size="sm">{contrato}</Button>
                                        }) : null}
                                    </ButtonGroup>
                                </ButtonToolbar>
                            </Row>
                            <Row className='bottom-row' lg='12' md='12' xs="12">
                                <Example
                                    data={dataGerencia ? (contratoActivo ? dataGerencia.data[contratoActivo] : []) : []} />
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalInformeRequerimientos);